 
import * as THREE from "../../../libs/three.js/build/three.module.js";


import Common from './Common.js'

class History extends THREE.EventDispatcher{
    
    constructor(o){ 
        super()
        
        this.undoList = []   
        this.redoList = [] 
        this.applyData = o.applyData    //应用数据的方法
        this.getData = o.getData        //获取数据的方法
        
        this.dataBefore 
        
        
       
        ;(o.viewer || viewer).inputHandler.addEventListener('keydown', (e)=>{
            if(e.keyCode == 90 && e.event.ctrlKey){//Z
                this.undo()
            }else if(e.keyCode == 89 && e.event.ctrlKey){//Y
                this.redo()
            }
        })
       
         
        
        
        
    }
    
    undo(){//回退 
        let length = this.undoList.length
         
        if(length>0){  
            let unExist 
            let last = this.undoList.pop(); 
            this.applyData && (unExist = !this.applyData(last.before)) 
            unExist || this.redoList.push(last); 
            unExist && this.undo()//找不到就回退下一个。
            this.dispatchEvent('undo')
            //console.log('undo',last)
        } 
    }
    
    
    redo(){//撤销回退 
        let length = this.undoList.length
        let last = this.redoList.pop();
        if(last){
            //注意：每行的顺序不能乱
            this.undoList.push(last)  
            this.applyData && this.applyData(last.after) 
            this.dispatchEvent('redo')
            //console.log('redo',last)
        }
    }
     
    
    beforeChange(o){//在变化之前（可能执行好几次直到变化完，但只有第一次有效）。 o的内容完全根据getData怎么定义
        if(!this.dataBefore){
            let data = this.getData(o)
            data && (this.dataBefore = data)
        } 
    } 
    
    afterChange(o){//变化结束，从beforeChange到此算一次操作。
        if(this.dataBefore){
            this.writeIn({before:this.dataBefore, after:this.getData(o)}     ) //写入某物体变化前和变化后的状态
            this.dataBefore = null  
        } 
    }
    
    writeIn(data ){ 
        this.redoList.length = 0; //一旦录入新的操作，就不允许undo了
        //console.log('writeIn',  data)    
        this.undoList.push(data );   
    }
    
    
    clear(){ 
        this.redoList.length = 0 
        this.undoList.length = 0 
        this.dataBefore = null
    } 
    
}


export default History